import "core-js/stable";
import "regenerator-runtime/runtime";

import Vue from "vue";
import App from "./App.vue";
import Components from "./components";
import router from "./router";
import store from "./store";
import Layouts from "@shared/Charts/Layouts/components";
import Authentication from "@shared/authentication";
import Filters from "./Filters";
import { mapGetters, mapActions } from "vuex";
import Bugsnag from "./utils/bugsnag";
import VueClipboard from "vue-clipboard2";
import VueIntercom from "vue-intercom";

import DcIcon from "@lab/components/dcicon/";
import Datepicker from "buefy/dist/components/datepicker";
import Select from "buefy/dist/components/select";
import Checkbox from "buefy/dist/components/checkbox";
import Input from "buefy/dist/components/input";
import Table from "buefy/dist/components/table";
import Tooltip from "buefy/dist/components/tooltip";

Vue.use(Authentication, { router });
Vue.use(Checkbox);
Vue.use(Components);
Vue.use(Datepicker);
Vue.use(DcIcon, {});
Vue.use(Filters);
Vue.use(Input);
Vue.use(Layouts);
Vue.use(Select);
Vue.use(Table);
Vue.use(Tooltip);
Vue.use(VueClipboard);
Vue.use(VueIntercom, {
	appId: process.env.VUE_APP_INTERCOM_APPID
});

Vue.config.productionTip = false;

// Make these values available across entire application
Vue.mixin({
	computed: {
		...mapGetters({
			currentUser: "userModule/get"
		})
	}
});

new Vue({
	el: "#app",
	router,
	store,
	components: {
		App
	},
	computed: {
		...mapGetters({
			token: "userModule/token"
		})
	},
	async mounted() {
		if (this.token) {
			await this.refresh();
		}
		if (this.currentUser) {
			Bugsnag.setUser(
				this.currentUser.id,
				this.currentUser.email,
				`${this.currentUser.firstname} ${this.currentUser.lastname}`
			);
			Bugsnag.addMetadata("user", {
				type: this.currentUser.type
			});
		}
		this.mountIntercom(this.$intercom);
	},
	methods: {
		...mapActions({
			refresh: "userModule/refresh",
			mountIntercom: "intercomModule/mounted"
		})
	},
	template: "<App/>"
});
